/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {KarenGameAssets} from "../KarenGameAssets";
import {Karen} from "../Karen";
import {KarenLayers, Layers} from "./KarenLayers";
import {TimelineLite, gsap} from "gsap";
import {BitMapFont} from "../../core/utils/BitMapFont";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {LayoutDimData, ResizeHelper} from "../../core/utils/ResizeHelper";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {GameHelper} from "../../core/utils/GameHelper";


export class KarenBackground extends PIXI.Container {
    private _gameLogo: PIXI.Sprite;
    private _gameLogoPost: PIXI.Sprite;
    private _background: PIXI.spine.Spine;
    private _backgroundImg: PIXI.Sprite;
    private _xWaySize: BitMapFont;
    private _fSBillboard: PIXI.Sprite;
    private _billBoardContainer: PIXI.Container;
    private _fsCounter: number = 0;
    private _xWayValue: number = 0;

    constructor() {
        super();
        this.init();
        this.onResize();
    }

    private static createBillBoard(): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(Karen.assetLoader.getTextures("FSBillboard")[0]);
        sprite.visible = false;
        return sprite;
    }

    public setXWaysFSSize(value: string): void {
        this._xWaySize.text = value;
        this._xWaySize.visible = true;
    }

    public setXWayValue(value: number): void {
        this._xWayValue = value;
    }

    public addNudgeToSize(duration: number = 0): TimelineLite {
        const valueToBeUpdated: number = (parseInt(this._xWaySize.text) + this._xWayValue);
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._xWaySize.text = valueToBeUpdated > 42 ? "42" : valueToBeUpdated + "";
            this._xWaySize.visible = true;
            const fsLeft: number = Karen.model.parsedGameData.freespinsLeft;
            Karen.keypadPlugin.setZeroBetSpinCounter(fsLeft);
        }, 0);
        tl.to(this, {}, duration);
        return tl;
    }

    public incrementxWayBy1(): void {
        const valueToBeUpdated: number = (parseInt(this._xWaySize.text) + 1);
        this._xWaySize.text = valueToBeUpdated > 42 ? "42" : valueToBeUpdated + "";
        this._xWaySize.visible = true;
    }
    public getXWaySize():string{
        return this._xWaySize.text;
    }
    public onSpinStart(): void {
        KarenLayers.getLayer(Layers.SYMBOL_MULT)!.children.length = 0;
    }

    public resetXWaySize(): void {
        this._xWaySize.text = "2";
    }

    public enableBillBoard(): void {
        this._fSBillboard.visible = true;
        this.setXWaysFSSize(this._xWaySize.text);
    }

    public hideBillBoard(): void {
        this._fSBillboard.visible = false;
        this._xWaySize.visible = false;
        this._xWaySize.text = "2";
    }

    public onResize(): void {
        if (NolimitApplication.isLandscape) {
            this._gameLogo.position.set(-160, 215);
            this._gameLogoPost.visible = false;
            this._gameLogo.visible = true;
            if (NolimitApplication.screenBounds.width < 970) { // 4:3 check
                this._gameLogo.visible = false;
                this._gameLogoPost.visible = false;
            }
        } else {
            this._gameLogo.visible = true;
            this._gameLogo.position.set(120, -105);
            this._gameLogoPost.visible = true;
        }
    }

    public updateBackGround(mode: string) {
        if (GameHelper.isFreeSpin(mode)) {
            this._backgroundImg.texture = Karen.assetLoader.getTextures(KarenGameAssets.FS_BACKGROUND)[0];
            this._background.state.setAnimation(0, "FSBGLoop", true);
        } else {
            this._backgroundImg.texture = Karen.assetLoader.getTextures(KarenGameAssets.MAIN_GAME_BACKGROUND)[0];
            this._background.state.setAnimation(0, "MainBGLoop", true);
        }
        this._background.position.set(360, 360);
        this._backgroundImg.position.set(360, 360);
        this._backgroundImg.anchor.set(0.5, 0.5);
        this._backgroundImg.position.set(360, 360);
    }

    private updateText(val: number): void {
        SlotGame.keypadPlugin.setZeroBetSpinCounter(val);
        this._fsCounter = val;
    }

    private init(): void {
        this._backgroundImg = new PIXI.Sprite(Karen.assetLoader.getTextures(KarenGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._background = new PIXI.spine.Spine(Karen.assetLoader.getSpineAsset("backgroundAnim"));
        this._background.state.setAnimation(0, "MainBGLoop", true);
        this._gameLogo = new PIXI.Sprite(Karen.assetLoader.getTextures("gameLogo")[0]);
        this._gameLogoPost = new PIXI.Sprite(Karen.assetLoader.getTextures("gameLogoPost")[0]);
        this._gameLogo.position.set(-160, 215);
        this._gameLogoPost.position.set(130, 30);
        this._backgroundImg.position.set(360, 360);
        this._backgroundImg.anchor.set(0.5, 0.5);
        this._background.position.set(360, 360);
        this._background.position.set(360, 360);
        this._xWaySize = new BitMapFont(KarenGameAssets.BITMAP_FONT_XWAYS, 12);
        this._xWaySize.position.set(190, 88);
        this._xWaySize.visible = false;
        this._billBoardContainer = new PIXI.Container();
        this._fSBillboard = KarenBackground.createBillBoard();
        this._fSBillboard.position.set(119, 20);
        this._billBoardContainer.addChild(this._fSBillboard, this._xWaySize);
        let layer: StageLayer | undefined = KarenLayers.getLayer(Layers.BACKGROUND);
        layer?.addChild(this._backgroundImg, this._background, this._gameLogo, this._gameLogoPost, this._billBoardContainer);
        if (layer !== undefined) {
            layer.onResize = () => this.onResize();
        }
    }
}
